import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const referencesFormSchema = (t: GetTextIdTranslationType) =>
  z.object({
    orderReference1: requiredString(t)
      .regex(/^[a-zA-Z0-9\\/\-_+@\s]*$/, t('REFERENCE_CHARACTER_NOT_ALLOWED'))
      .trim(),
    orderReference2: z
      .string()
      .regex(/^[a-zA-Z0-9\\/\-_+@\s]*$/, t('REFERENCE_CHARACTER_NOT_ALLOWED'))
      .trim()
      .optional(),
  });

export type referencesFormType = z.infer<ReturnType<typeof referencesFormSchema>>;
